export const TEXT_WIDGET_VARIANTS = {
  drawerTitle: {
    color: 'presets.turquoise.100',
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '2px',
  },
} as const

export type TextWidgetVariant = keyof typeof TEXT_WIDGET_VARIANTS

export const TextLayout = {
  variant: (variant?: TextWidgetVariant) =>
    variant ? TEXT_WIDGET_VARIANTS[variant] : {},
} as const
